function initPage8(vm) {
	vm.listFileName = [ {
		valueFile : 1,
		fileName : 'Tóm tắt bệnh án'
	}, {
		valueFile : 2,
		fileName : 'Tóm tắt bệnh án 1'
	}, {
		valueFile : 3,
		fileName : 'Tóm tắt bệnh án 2'
	} ];

	vm.quantity = [ {
		quantityCode : 1,
		quantityName : 1
	}, {
		quantityCode : 2,
		quantityName : 2
	}, {
		quantityCode : 3,
		quantityName : 3
	}, {
		quantityCode : 4,
		quantityName : 4
	} ];

	vm.listFileClaim = [ {
		listFileName : vm.listFileName,
		quantity : vm.quantity,
		receiveDate : '',
		note : '',
		hopLe : true,
		fileName : {
			valueFile : 0,
			fileName : ''
		},
		quantityNum : {
			quantityCode : 0,
			quantityName : 0
		},
		receive : '',
		noteDetail : '',
		checked : false
	} ];
	
	vm.addNewRow = function() {
//		if (vm.listFileClaim[vm.listFileClaim.length - 1].fileName.valueFile !== 0) {
			vm.listFileClaim.push({
				listFileName : vm.listFileName,
				quantity : vm.quantity,
				receiveDate : '',
				note : '',
				hopLe : true
			});
//		}
	}
	
	vm.deleteOneItem = function(index) {
		delete vm.listFileClaim.splice(index, 1);
	}
}
